/**
  * @class meleActorGps
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-gps>` custom web element for playing GPS position from mmGps in <mele-channel>
  */

import meleActor from 'meleActor'
import geo from 'msysGeo'

const PROPERTIES = _.extend({}, {
}, meleActor._properties)

export default class meleActorGps extends meleActor {
  init() {
    super.init()
    this.classList.add('indicator')
  } // init

  message({ params }) {
    const [lat, lng] = geo.toLatLng(params.gps)
    this.innerHTML = params.gps ? `<mele-text class="title" label="app.gps"></mele-text><span class="subtitle">${lat} ${lng}</span>` : ''
  } // message
} // class meleActorGps

meleActorGps._properties = PROPERTIES
meleActorGps.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-gps', meleActorGps)
